import React from 'react';

import PropTypes from 'prop-types';
import { isArray } from 'lodash';

import { t } from '~/helpers';

import { Card } from '..';

// Serialize objects
function handleSerializeObject({
  codigotanquefisico,
  nomeproduto,
  corproduto,
  volumeespacovazioestoqueproduto,
  capacidadeoperacionaltanquefisico,
  volumeestoqueproduto,
  datahoraestoqueproduto,
}) {
  return {
    titulo: `${codigotanquefisico} - ${nomeproduto.toUpperCase()}`,
    cor: corproduto,
    capacidade: capacidadeoperacionaltanquefisico,
    espacoVazio: volumeespacovazioestoqueproduto,
    saldo: volumeestoqueproduto,
    atualizacao: datahoraestoqueproduto,
  };
}

export default function List({ refresh, get, ...rest }) {
  return (
    <>
      <Card
        refreshProduct={() =>
          refresh({ ...rest, idposto: rest.post_cod_posto, read: () => get() })
        }
        //station={handleSerializeObject(rest)}
        station={rest}
      />

      {isArray(rest.produtos) &&
        rest.produtos.map((product) => (
          <Card
            refreshProduct={() =>
              refresh({ ...product, idposto: rest.idposto, read: () => get() })
            }
            station={handleSerializeObject(product)}
          />
        ))}
    </>
  );
}

List.propTypes = {
  refresh: PropTypes.func.isRequired,
  get: PropTypes.func.isRequired,
};
